import { createAction } from "@reduxjs/toolkit";
import {MapState} from "../../../components/map/Map/Map";
import {LocationHistoryMapFilter} from "../../../model/location-history";

export const setLocationHistoryMapState = createAction<MapState>("location-history-map-page/setState");
export const setLocationHistoryMapFilter = createAction<LocationHistoryMapFilter>("location-history-map-page/setFilter");
export const setLocationHistoryMapDate = createAction<number>("location-history-map-page/setDate");
